<template>
    <div class="card-box">
        <h4 class="header-title m-t-0 m-b-20 text-dark">{{ $t('open_deals_by_member') }}</h4>
        <div v-pml-block="isLoading" style="min-height: 280px;">
            <div style="height: 280px;" ref="openByMembers" v-show="hasRegistry"></div>
            <pml-ec-pizza v-if="!hasRegistry"></pml-ec-pizza>
        </div>
    </div>
</template>

<script>
    import c3 from 'c3'
    import * as d3 from 'd3'
    import { getOpenByMembers } from 'services/dashboard'

    export default {
        name: 'OpenByMembers',
        data () {
            return {
                isLoading: false,
                openByMembers: {
                    data: []
                }
            }
        },
        computed: {
            hasRegistry () {
                return this.openByMembers.data.length !== 0
            }
        },
        mounted () {
            this.initOpenByMembers()
        },
        methods: {
            initOpenByMembers () {
                this.isLoading = true

                getOpenByMembers()
                    .then(response => {
                        this.isLoading = false
                        this.openByMembers = response.data

                        c3.generate({
                            bindto: this.$refs.openByMembers,
                            data: {
                                columns: this.openByMembers.data,
                                type: 'pie'
                            },
                            pie: {
                                label: {
                                    show: false
                                }
                            },
                            legend: {
                                position: 'right'
                            },
                            tooltip: {
                                format: {
                                    value (value, ratio, id, index) {
                                        return `&nbsp;${d3.format('.1%')(ratio)} (${value})`
                                    }
                                }
                            }
                        })
                    })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/reports/deals/components/OpenDealsByMember.vue